module.exports = __webpack_public_path__ + "img/logo_poisk.ab255ca0.png";